import { unwrapResult } from "@reduxjs/toolkit";
import useOpenClose from "hooks/useOpenClose";
import ConfirmationModal from "library/Molecules/Modal/ConfirmationModal";
import useOrders from "pages/Dashboard/hooks/useOrders";
import { PropTypes } from "prop-types";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { cancelOrderRequest } from "store/requests/order.requests";

const ConfirmCancelOrderModal = ({ onClose }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [{ selectedOrder }] = useOrders();

  const [isLoading, startLoading, stopLoading] = useOpenClose(false);

  const handleConfirm = useCallback(() => {
    startLoading();
    dispatch(cancelOrderRequest(selectedOrder.id))
      .then(unwrapResult)
      .catch(() => {})
      .finally(() => {
        onClose();
        stopLoading();
      });
  }, [dispatch, onClose, selectedOrder.id, startLoading, stopLoading]);

  return (
    <ConfirmationModal
      id={`cancel-${selectedOrder?.reference}-order-modal`}
      title={t("dashboard.modals.cancelOrderModal.title")}
      description={t("dashboard.modals.cancelOrderModal.description", { reference: selectedOrder?.reference })}
      onConfirm={handleConfirm}
      onDecline={onClose}
      declineBtnText={t("common.buttons.backToBtn", { context: "order" })}
      confirmBtnText={t("common.buttons.cancelOrderBtn")}
      isDataProcessing={isLoading}
    />
  );
};

ConfirmCancelOrderModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default ConfirmCancelOrderModal;
